import { FilterList, PillListProps } from "./types";

import AcIcon from "icons/acSmall.svg";
import { FunctionComponent } from "react";
import NonAcIcon from "icons/nonAC.svg";
import SeaterIc from "icons/seater.svg";
import SleeperIc from "icons/sleeperSmall.svg";
import Star from "icons/rating.svg";
import Pill from "components/pill";

const PillList: FunctionComponent<PillListProps> = (props) => {
  const { data, onClick } = props;
  const getIcons = (type: string) => {
    switch (type) {
      case "Top rated":
      case "5":
      case "4 & above":
      case "3 & above":
        return Star;
      case "AC":
        return AcIcon;
      case "Non-AC":
        return NonAcIcon;
      case "Seater":
        return SeaterIc;
      case "Sleeper":
        return SleeperIc;

      default:
        return Star;
    }
  };

  return (
    <div data-testid="pill-list">
      {data?.map((item: FilterList, index: number) => (
        <Pill
          key={index}
          showIcon={true}
          title={item.title}
          icon={getIcons(item.title)}
          selected={item.selected}
          wrapperClass="mr-3 mb-3"
          description={item.description}
          onClick={() => {
            onClick(item, index);
          }}
        />
      ))}
    </div>
  );
};

export default PillList;
